var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { Radio } from '../Radio';
import { radioCardClass } from './styles';
/**
 * Use RadioCard to select a single option from a list.
 * Radio should be used instead of checkboxes if only one item can be selected from a list.
 * @author Alan Chávez<alan.chavez@evacenter.com>
 * Created at 2022-04-28
 */
export var RadioCard = forwardRef(function (_a, ref) {
    var radioCardClassName = _a.radioCardClassName, children = _a.children, restOfProps = __rest(_a, ["radioCardClassName", "children"]);
    var checked = restOfProps.checked, disabled = restOfProps.disabled;
    return (React.createElement("label", { ref: ref, className: radioCardClass(radioCardClassName, checked, disabled), "data-testid": "radio-card" },
        React.createElement(Radio, __assign({}, restOfProps)),
        children));
});
